import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ABTEST$ACCORDION$ADV;

// This file provides node rules for structured-content JSON document
import { ABTEST, ACCORDION, ADVERTISERDISCLOSURE, ANCHORLINK, ANCHORLINKTARGET, APOLLOINTEGRATIONCANARY, ARTICLEHERO, AUTHLINK, AUTOINSURANCEENTRYPOINT, AUTOINSURANCEQUOTES, BACKTOTOPLINK, BUTTON, CALCULATION, CALCULATOR, CALCULATORCONDITIONAL, CALCULATORINPUT, CALCULATORRADIO, CALCULATORSELECT, COLUMN, COLUMNS, CONTAINER, CONTENTHEADING, CONTENTIMAGE, CONTENTQUOTE, DIVIDER, DOCUMENT, DROPCAPS, FAQ, FUNDERALOANOPTIONCTA, HEADING, HLMENTRY, HOMEINSURANCEENTRYPOINT, HOUSEAD, IMAGE, LINK, LIST, LISTITEM, MARKETPLACEAPPLYNOW, MARKETPLACECOMPARISONLINK, MARKETPLACECOMPARISONTABLE, MARKETPLACEFIELD, MARKETPLACEPARTNERPLACEMENT, MARKETPLACEPRODUCTCARD, MARKETPLACESTARRATING, MARKETPLACERATETABLE, MARKETPLACETHIRDPARTYEMBED, MEGAPHONEFM, MINIPRODUCTCARD, MORELINK, MORTGAGELENDERINTERACTIVECOMPARISON, NERDTIP, NOOP, OUTOFDATEMESSAGE, POSTLIST, PREQUALAPPLICATIONHOUSEAD, PRODUCTSTARRATING, RENDERCONTEXTCONDITIONAL, SCREENSIZECONDITIONAL, SOCIALMEDIALINKS, SPOTIFY, STARRATING, TABLE, TABLEOFCONTENTS, TIKTOK, TWITTER, TYPE, VIDEO, USERSEGMENTCONDITIONAL, WPCALCULATOR, WPEMBED, WPHOUSEAD, WPPOSTLIST, WPTABLE, TABLEOFCONTENTSTARGET, MARKETPLACEENTITYDISPLAYNAME } from './types'; // eslint-disable-next-line camelcase

import migrateAccordionFrom_1_0_0_to_2_0_0 from './components/accordion/migrations/2.0.0'; // eslint-disable-next-line camelcase

import migrateColumnsFrom_1_0_0_to_2_0_0 from './components/columns/migrations/2.0.0'; // eslint-disable-next-line camelcase

import migrateWpPostListFrom_1_0_0_to_2_0_0 from './components/wp-post-list/migrations/2.0.0';
export default (_ABTEST$ACCORDION$ADV = {}, _defineProperty(_ABTEST$ACCORDION$ADV, ABTEST, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, ACCORDION, {
  nodeProps: ['panels.*.children', 'panels.*.label', 'panels.*.labelCollapsed'],
  version: '2.0.0',
  migrations: {
    '2.0.0': migrateAccordionFrom_1_0_0_to_2_0_0
  }
}), _defineProperty(_ABTEST$ACCORDION$ADV, ADVERTISERDISCLOSURE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, ANCHORLINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, ANCHORLINKTARGET, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, APOLLOINTEGRATIONCANARY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, ARTICLEHERO, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, AUTHLINK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, AUTOINSURANCEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, AUTOINSURANCEQUOTES, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, BACKTOTOPLINK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, BUTTON, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CALCULATION, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CALCULATOR, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CALCULATORCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CALCULATORINPUT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CALCULATORRADIO, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CALCULATORSELECT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, COLUMN, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, COLUMNS, {
  nodeProps: ['children'],
  version: '2.0.0',
  migrations: {
    '2.0.0': migrateColumnsFrom_1_0_0_to_2_0_0
  }
}), _defineProperty(_ABTEST$ACCORDION$ADV, CONTAINER, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CONTENTHEADING, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CONTENTIMAGE, {
  nodeProps: ['children', 'caption'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, CONTENTQUOTE, {
  nodeProps: ['children', 'author', 'authorTitle'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, DIVIDER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, DOCUMENT, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, DROPCAPS, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, FAQ, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, FUNDERALOANOPTIONCTA, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, HEADING, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, HLMENTRY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, HOMEINSURANCEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, HOUSEAD, {
  nodeProps: ['ctaNode'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, IMAGE, {
  nodeProps: ['children', 'caption'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, LINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, LIST, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, LISTITEM, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACEAPPLYNOW, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACECOMPARISONLINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACECOMPARISONTABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACEENTITYDISPLAYNAME, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACEFIELD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACEPARTNERPLACEMENT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACEPRODUCTCARD, {
  nodeProps: ['bottomLine'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACESTARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACERATETABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MARKETPLACETHIRDPARTYEMBED, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MEGAPHONEFM, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MINIPRODUCTCARD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MORELINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, MORTGAGELENDERINTERACTIVECOMPARISON, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, NERDTIP, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, NOOP, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, OUTOFDATEMESSAGE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, POSTLIST, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, PREQUALAPPLICATIONHOUSEAD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, PRODUCTSTARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, RENDERCONTEXTCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, SCREENSIZECONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, SOCIALMEDIALINKS, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, SPOTIFY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, STARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, TABLE, {
  nodeProps: ['columns.*.heading', 'data.*.cells.*'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, TABLEOFCONTENTS, {
  nodeProps: ['items.*.title'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, TABLEOFCONTENTSTARGET, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, TIKTOK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, TWITTER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, TYPE, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, VIDEO, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, USERSEGMENTCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, WPCALCULATOR, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, WPEMBED, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, WPHOUSEAD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ADV, WPPOSTLIST, {
  nodeProps: [],
  version: '2.0.0',
  migrations: {
    '2.0.0': migrateWpPostListFrom_1_0_0_to_2_0_0
  }
}), _defineProperty(_ABTEST$ACCORDION$ADV, WPTABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _ABTEST$ACCORDION$ADV);